import React, {Component} from 'react';
import {Checkbox} from "@blueprintjs/core";
import {isInt} from 'validator';

// Components
import Select from "../../components/common/virtualized-select";
import {documentTypes} from "../common/document_types";

class CreateSerieDialog extends Component {
    constructor(props) {
        super(props);
        this.state = {
            document_type: -1,
            name: '',
            prefix: '',
            number_length: 3,
            last_count: 0,
            is_default: true
        }
    }

    componentDidMount() {
        this.props.onRef(this);
    }

    componentWillUnmount() {
        this.props.onRef(undefined);
    }

    onCreateButtonClick = () => {
        this.props.createSerie({
            document_type: this.state.document_type,
            name: this.state.name,
            prefix: this.state.prefix,
            number_length: this.state.number_length,
            last_count: this.state.last_count,
            is_default: this.state.is_default,
        });
        this.props.onCloseModal();
    };

    validateSubmit = () => {
        const canSubmit = this.state.document_type !== -1 &&
            this.state.document_type !== -1 &&
            this.state.name !== '' &&
            this.state.number_length >= 3 &&
            this.state.last_count !== ''
        ;

        this.props.onCanSubmit(canSubmit);
    };

    render() {
        return (
            <div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Tipo de documento *</label>
                        <Select
                            className="virtualized-select"
                            options={documentTypes.toJS()}
                            value={this.state.document_type}
                            labelKey="desc"
                            valueKey="type"
                            matchProp="desc"
                            multi={false}
                            searchable={true}
                            clearable={false}
                            onChange={(document_type) => { if (document_type) this.setState({ document_type: document_type.type }, this.validateSubmit) }}
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Nombre *</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.name}
                            onChange={(event) => this.setState({ name: event.target.value }, this.validateSubmit) }
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Prefijo</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.prefix}
                            onChange={(event) => this.setState({ prefix: event.target.value }) }
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Dígitos (mínimo 3) *</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.number_length}
                            onChange={(event) => {
                                let number_length = event.target.value;

                                if (isInt(number_length) || number_length === '') {
                                    this.setState({ number_length }, this.validateSubmit);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="row modal-row">
                    <div className="col">
                        <label style={{color: 'black', fontSize: 14, fontWeight: 600}}>Último número *</label>
                        <input
                            className="form-control"
                            type="text"
                            value={this.state.last_count}
                            onChange={(event) => {
                                let last_count = event.target.value;

                                if (isInt(last_count) || last_count === '') {
                                    this.setState({ last_count }, this.validateSubmit);
                                }
                            }}
                        />
                    </div>
                </div>
                <div className="row modal-row" style={{ paddingTop: 15 }} >
                    <div className="col-1">
                        <Checkbox
                            checked={this.state.is_default}
                            onChange={event => this.setState({ is_default: event.target.checked })}
                        />
                    </div>
                    <div className="col" style={{ paddingLeft: 0 }} >
                        <span style={{ fontSize: 14 }} >Marcar como <strong>serie por defecto</strong> para este tipo de documentos</span>
                    </div>
                </div>
            </div>
        );
    }
}

export default CreateSerieDialog;


// WEBPACK FOOTER //
// ./src/components/dialogs/CreateSerieDialog.js